import { EventCategory } from "./type";

export const EN_EVENT_CATEGORY: EventCategory = {
  all: "All",
  workshop: "Workshop",
  course: "Course",
  meetup: "Meetup"
};
